import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
interface FaqItemProps {
  question: string;
  answer: string;
}
function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-card last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-2">
        <span className="text-lg font-bold text-white group-hover:text-brand-gold transition-colors" data-id="element-3">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-4" />
      </button>
      <AnimatePresence data-id="element-5">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-6">
            <p className="pb-6 text-brand-muted leading-relaxed" data-id="element-7">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqSection() {
  const faqs = [{
    question: '¿Y si no gano mucho?',
    answer: "Entonces esto es más urgente. El orden no es para 'ricos'; el orden es para no diluir. Si tienes poco, cada error te cuesta el doble."
  }, {
    question: '¿Y si estoy endeudado?',
    answer: 'Perfecto. Orden primero, plan después. Sin orden, cualquier plan para salir de deudas se rompe a la primera urgencia.'
  }, {
    question: '¿Necesito 4 cuentas ya?',
    answer: 'No. Empiezas mínimo viable (2) y escalas. El manual te guía paso a paso para que no te compliques.'
  }];
  return <section className="w-full px-4 md:px-6" data-id="element-8">
      <div className="max-w-2xl mx-auto" data-id="element-9">
        <FadeIn data-id="element-10">
          <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-11">
            Preguntas que te van a venir
          </h2>
          <div className="bg-brand-card/30 rounded-xl p-6 md:p-8 border border-brand-bg" data-id="element-12">
            {faqs.map((faq, i) => <FaqItem key={i} {...faq} data-id="element-13" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}